import { render, staticRenderFns } from "./UserAvatarInitials.vue?vue&type=template&id=1802a961&scoped=true&"
import script from "./UserAvatarInitials.vue?vue&type=script&lang=js&"
export * from "./UserAvatarInitials.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarInitials.vue?vue&type=style&index=0&id=1802a961&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1802a961",
  null
  
)

export default component.exports